import { GradeRange } from "@/components/ContentPromotions/types";

const formatGradeRangeString = (
  gradeRange: GradeRange,
  useLowerCasePrefix = false,
) => {
  const { min_grade: minGrade, max_grade: maxGrade } = gradeRange;

  const prefixText = useLowerCasePrefix ? "grade" : "Grade";

  if (minGrade === maxGrade) {
    return minGrade === 0
      ? `${prefixText} ${minGrade}`.replace("0", "K")
      : `${prefixText} ${minGrade}`;
  } else {
    const formattedMinGrade = minGrade === 0 ? "K" : minGrade;
    const formattedMaxGrade = maxGrade === 0 ? "K" : maxGrade;

    return `${prefixText}s ${formattedMinGrade}-${formattedMaxGrade}`;
  }
};

export default formatGradeRangeString;
